
interface DeviceStatusFilterProps {
  statusFilter: string | null;
  onStatusClick: (status: string | null) => void;
  counts: {
    active: number;
    inactive: number;
    pending: number;
    total: number;
  };
  isLoading: boolean;
}

export const DeviceStatusFilter = ({ 
  statusFilter, 
  onStatusClick,
  counts,
  isLoading
}: DeviceStatusFilterProps) => {
  // This component no longer displays status cards
  return null;
};
